// reducers.ts
import { createReducer } from "@reduxjs/toolkit";
import { updateProfile, reset } from "../actions/ProfileActions";
import { AppState } from "../types/appState";
import { BundleEntry, ExtractResource } from "@medplum/fhirtypes";

const initialState: AppState = {
  profile: {},
};

export const appReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(updateProfile, (state, action) => {
      state.profile = action.payload;
    })
    .addCase(reset, (state) => {
      state.profile = {};
    });
});
